import * as R from 'ramda'
import * as District from 'models/districts'

export const RETRIEVE_ONE_DISTRICT_FROM_CACHE =
  'RETRIEVE_ONE_DISTRICT_FROM_CACHE'
export const REQUEST_ONE_DISTRICT = 'REQUEST_ONE_DISTRICT'
export const RECEIVE_ONE_DISTRICT = 'RECEIVE_ONE_DISTRICT'
export const RECEIVE_ERROR = 'districts/RECEIVE_ERROR'

// const isCached = (lastUpdated, cacheDuration) =>
//   Date.now() - lastUpdated <= cacheDuration

const receiveError = (error, districtId) => ({
  type: RECEIVE_ERROR,
  districtId,
  error
})

const requestOneDistrict = districtId => ({
  type: REQUEST_ONE_DISTRICT,
  districtId
})

const receiveOneDistrict = (districtId, data) => {
  const district = R.omit(['schools'], data)
  district.schools = R.map(R.prop('school_id'), data.schools)
  const schoolAry = R.map(
    school => ({
      ...school,
      district_id: district.district_id,
      flyers: [...(school.flyers || [])]
    }),
    data.schools
  )
  const schools = R.reduce(
    (accum, school) => ({ ...accum, [school.school_id]: school }),
    {},
    schoolAry
  )
  return {
    type: RECEIVE_ONE_DISTRICT,
    districtId,
    schools,
    district,
    receivedAt: Date.now()
  }
}

// const retrieveOneDistrictFromCache = {
//   type: RETRIEVE_ONE_DISTRICT_FROM_CACHE
// }

export const fetchOneDistrict = districtId => (dispatch /* getState */) => {
  // const THIRTY_MINUTES = 30 * 60 * 1000 * 1000
  // const state = getState()
  // const lastUpdated = state.flyers.lastUpdated

  // if (isCached(lastUpdated, THIRTY_MINUTES)) {
  //   dispatch(retrieveOneDistrictFromCache)
  //   return false
  // }

  dispatch(requestOneDistrict(districtId))
  return District.getOne(districtId)
    .then(json => dispatch(receiveOneDistrict(districtId, json)))
    .catch(err => dispatch(receiveError(err, districtId)))
}



// WEBPACK FOOTER //
// ./src/shared/redux/districts/actions.js